// app.routes.ts
import { Routes } from '@angular/router';
import { MapsSdkResolver } from '@uzurv/rideWss/app/resolvers/maps-sdk.resolver';
import { GoogleAnalyticsResolver } from '@uzurv/rideWss/app/resolvers/google-analytics.resolver';
import { AuthGuard } from './guards';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/authentication/authentication.routes').then((m): Routes => m.authenticationRoutes)
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.routes').then((m): Routes => m.registrationRoutes)
  },
  {
    path: 'rides',
    canActivate: [AuthGuard()],
    resolve: {
      mapsSdk: MapsSdkResolver,
      googleAnalytics: GoogleAnalyticsResolver
    },
    loadChildren: () => import('./pages/rides/rides.routes').then(m => m.routes)
  },
  {
    path: 'account',
    canActivate: [AuthGuard()],
    loadChildren: () => import('./pages/account/account.routes').then(m => m.routes)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
